import PhoneConfirm from './PhoneConfirm';

export default PhoneConfirm;
